import React from 'react';
import { useState } from 'react';

export default function DataApiDebug ({ data }) {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const renderTraceItem = (item, index) => {
    if (typeof item === 'string') {
      return (
        <div key={`string-${index}`} className="trace-string">
          <p>{item}</p>
        </div>
      );
    }

    return ( 
      <div key={`trace-${index}`} className="trace-item">
        <h4 onClick={() => toggleSection(`trace-${index}`)} style={{textAlign: 'start'}}>
          {item?.what} {expandedSections[`trace-${index}`] ? '▼' : '▶'}
        </h4>
        
        {expandedSections[`trace-${index}`] && (
          <div className="trace-details">
            {item?.condition && (
              <div className="condition-section mt-4">
                <h5>Condition:</h5>
                <pre>{JSON.stringify(item?.condition, null, 2)}</pre>
              </div>
            )}
            
            {item?.priceCondition && (
              <div className="price-condition">
                <h5>Price Condition:</h5>
                <pre>{JSON.stringify(item?.priceCondition, null, 2)}</pre>
              </div>
            )}
            
            {item?.stockCondition && (
              <div className="stock-condition">
                <h5>Stock Condition:</h5>
                <pre>{JSON.stringify(item?.stockCondition, null, 2)}</pre>
              </div>
            )}
            
            {item?.data && (
              <div className="data-section">
                <h5>Data:</h5>
                <pre>{JSON.stringify(item?.data, null, 2)}</pre>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
    {
      data ? (
        <div className="api-data-viewer w-100">
        <div className="container w-100" style={{backgroundColor: '#014788'}}>
          <h2 style={{color: '#FFFFFF', textAlign: 'center', padding: '5px 0'}}>API Debug Information</h2>
        </div>
        <div className="section">
          <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e2cc'}}>
            <h3 className='m-0'>
              Basic Information
            </h3>
            <span onClick={() => toggleSection('basicInfo')} style={{fontSize: 17}}>{expandedSections?.basicInfo ? '▼' : '▶'}</span>
          </div>
          {expandedSections?.basicInfo && (
            <div className="basic-info" style={{padding: '25px 45px'}}>
              {/* <p><strong>ID:</strong> {data._id}</p> */}
              <p><strong>Action:</strong> {data.doing}</p>
              <p><strong>Created At:</strong> {new Date(data.createdAt).toLocaleString()}</p>
              <p><strong>Updated At:</strong> {new Date(data.updatedAt).toLocaleString()}</p>
            </div>
          )}
        </div>
        
        <div className="section">
          <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e242'}}>
            <h3 className='m-0'>
                Trace Log
            </h3>
            <span onClick={() => toggleSection('trace')} style={{fontSize: 17}}>{expandedSections?.trace ? '▼' : '▶'}</span>
          </div>
          {expandedSections?.trace && (
            <div className="trace-log" style={{padding: '25px 45px'}}>
              {data.trace.map((item, index) => renderTraceItem(item, index))}
            </div>
          )}
        </div>
        
        <div className="section">
          <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e2cc'}}>
            <h3 className='m-0'>
              Product Reference
            </h3>
            <span onClick={() => toggleSection('productRef')} style={{fontSize: 17}}>{expandedSections?.productRef ? '▼' : '▶'}</span>
          </div>
          {expandedSections?.productRef && (
            <div className="product-info" style={{padding: '25px 45px'}}>
              <h4>Basic Info</h4>
              <p><strong>ID:</strong> {data.data.productRef._id}</p>
              <p><strong>Title:</strong> {data.data.productRef.title}</p>
              <p><strong>Price:</strong> ${data.data.productRef.price}</p>
              <p><strong>Stock:</strong> {data.data.productRef.stock}</p>
              
              <h4>Attributes</h4>
              <pre>{JSON.stringify(data.data.productRef.attrib, null, 2)}</pre>
              
              <h4>Linked Products</h4>
              <ul>
                {data.data.productRef.linkedTo.map((link, i) => (
                  <li key={i}>
                    ID: {link.id}, Multiplier: {link.priceMultiplier}, Divisor: {link.stockDivisor}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        
        <div className="section">
          <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e242'}}>
            <h3 className='m-0'>
                Linked Product
            </h3>
            <span onClick={() => toggleSection('linkedProduct')} style={{fontSize: 17}}>{expandedSections?.linkedProduct ? '▼' : '▶'}</span>
          </div>
          {expandedSections?.linkedProduct && (
            <div className="linked-product-info" style={{padding: '25px 45px'}}>
              <h4>Basic Info</h4>
              <p><strong>ID:</strong> {data.data.linked._id}</p>
              <p><strong>Title:</strong> {data.data.linked.title}</p>
              <p><strong>Price:</strong> ${data.data.linked.price}</p>
              <p><strong>Stock:</strong> {data.data.linked.stock}</p>
              
              <h4>Attributes</h4>
              <pre>{JSON.stringify(data.data.linked.attrib, null, 2)}</pre>
              
              <h4>Enterprise Info</h4>
              <p><strong>Name:</strong> {data.data.linked.enterprise.name}</p>
              <p><strong>Address:</strong> {data.data.linked.enterprise.direccion}</p>
              
              <h4>Linked Products</h4>
              <ul>
                {data.data.linked.linkedTo.map((link, i) => (
                  <li key={i}>
                    ID: {link.id}, Multiplier: {link.priceMultiplier}, Divisor: {link.stockDivisor}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      ):
      <p>No data available.</p>
      }
    </>
  );
}